import { apiClient } from "./api";

export default {
  getOrdersListList() {
    return apiClient.post(`/order/list`, { action: "action=orderlist" });
  },
  getOrdersByVendors() {
    return apiClient.post(`/order/all`, { action: "action=orderall" });
  },
  getVendors() {
    return apiClient.post(`/vendor/list`, {});
  },
  getEachOrder(id: Number) {
    return apiClient.post(`/order/info`, { id: id });
  },
};
